import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from './create-telemetry-service';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import React from 'react';

const reactPlugin = new ReactPlugin();

export const aiInit = (key: string): unknown => {
    const ai = new ApplicationInsights({
        config: {
            instrumentationKey: key,
            extensions: [reactPlugin],
        },
    });

    ai.loadAppInsights();
    return ai.appInsights;
};

reactPlugin.trackEvent = function (event, customProperties) {
    this._analyticsPlugin?.trackEvent(event, customProperties);
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default (Component: React.ComponentType): React.ComponentClass => withAITracking(reactPlugin, Component);
export const appInsights = ai.appInsights;
export { reactPlugin };
